import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-prestation-to-invoice',
  templateUrl: './prestation-to-invoice.component.html',
  styleUrls: ['./prestation-to-invoice.component.scss']
})
export class PrestationToInvoiceComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
